/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findAll18 } from '../fn/agn-presence-type/find-all-18';
import { FindAll18$Params } from '../fn/agn-presence-type/find-all-18';
import { PresenceType } from '../models/presence-type';

@Injectable({ providedIn: 'root' })
export class AgnPresenceTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll18()` */
  static readonly FindAll18Path = '/api/values/agn-presence-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll18()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll18$Response(params?: FindAll18$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PresenceType>>> {
    return findAll18(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll18$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll18(params?: FindAll18$Params, context?: HttpContext): Observable<Array<PresenceType>> {
    return this.findAll18$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PresenceType>>): Array<PresenceType> => r.body)
    );
  }

}
